import LogsPanelContext from '@crm/contexts/LogsPanelContext'
import * as React from 'react'

import { MeetingForm } from './MeetingForm'

export const CreateMeeting = () => {
  const { toggleCreateMeeting } = React.useContext(LogsPanelContext)

  return <MeetingForm onCloseForm={toggleCreateMeeting} />
}
